<template>
  <div>
    <dv-full-screen-container class="bg">
      <div class="header">
        <div class="show-headder-left">
          <!-- 左侧顶端装饰 -->
          <dv-decoration-1 style="width:200px;height:50px;" />  <!-- 装饰1 -->
          <dv-decoration-3 style="width:250px;height:30px;" />  <!-- 装饰2 -->
        </div>
        <div class="show-h1"><h1>兖煤集团·赵楼煤矿 设备运行状态监控看板</h1></div>
        <div class="show-time">{{newTime}}</div>
      </div>


      <!-- 页面主体 -->
      <div class="mainbox">
        <!-- left-box -->
        <div class="column">
          <div class="panel bar">
            <!--<h2>柱形图</h2>-->
            <!-- 图表放置盒子 -->
            <div class="chart_gauge">
              <div style="width:50%">
                <echartGauge1 :id="id_gauge_1" :echartTitle="eTitle_gauge_1"></echartGauge1>
              </div>
              <div style="width:50%">
                <echartGauge2 :id="id_gauge_2" :echartTitle="eTitle_gauge_2"></echartGauge2>
              </div>
<!--              <dvProduct1></dvProduct1>  产量统计-->
            </div>
            <!-- 伪元素绘制盒子下边角 -->
            <div class="panel-footer"></div>
          </div>

          <div class="panel line">

            <div class="chart_gauge">
              <div style="width:50%">
                <echart-torque1 :id="id_torque_1" :echartTitle="eTitle_torque_1"></echart-torque1>
              </div>
              <div style="width:50%">
                <echart-torque2 :id="id_torque_2" :echartTitle="eTitle_torque_2"></echart-torque2>
              </div>
            </div>

            <div class="panel-footer"></div>
          </div>

          <div class="panel pie">

            <div class="chart">
              <dv-em-position :id="idPos" :echartTitle="eTitle_pos"></dv-em-position>  <!--箕斗位置 -->
            </div>

            <div class="panel-footer"></div>
          </div>
        </div>
        <!-- middle-box -->
        <div class="column">
          <!-- 头部 no模块 -->
          <runningStatus></runningStatus>

          <!-- middle-map -->
          <div class="map">
            <div class="map1"></div>
            <div class="map2"></div>
            <div class="map3"></div>
            <div class="chart">
              <dvMap :id="id4" :echartTitle="eTitle4"></dvMap>
            </div>
            <div class="chart-center-bottom">
              <!-- 中间底部边框 dataV -->
              <dv-border-box-12>
                <!--这个没有加ID参数-->
                <echartCenterBottom></echartCenterBottom>
              </dv-border-box-12>
            </div>
          </div>
        </div>

        <!-- right-box -->
        <div class="column">
          <div class="panel bar2">
<!--            <h2>右一水位图</h2>-->
            <div class="chart">
              <echart5 :id="id5" :echartTitle="eTitle5"></echart5>  <!-- 定子电流 -->
            </div>
            <div class="panel-footer"></div>
          </div>
          <div class="panel line2">
            <div class="chart">
              <echart6 :id="id6" :echartTitle="eTitle6"></echart6>  <!-- 励磁电流 -->
            </div>
            <div class="panel-footer"></div>
          </div>
          <div class="panel pie2">
            <div class="chart">
              <echart2 :id="id2" :echartTitle="eTitle2"></echart2> <!-- 主电机温度柱状图 -->
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>

    </dv-full-screen-container>
  </div>
</template>

<script>

import screenfull from 'screenfull'
import EmCommonApi from "@/mixin/em/common/api";

//自定义组件
import runningStatus from "@/views/em/kpiLayout/charts/running_status";   //提升机运行状态
// import dvProduct1 from "@/views/em/kpiLayout/charts/dvProduct_1";      //产量统计列表
import dvEmPosition from "@/views/em/kpiLayout/charts/dvEmPosition";      //提升机箕斗位置

//import eChart
import echartGauge1 from "@/views/em/kpiLayout/charts/echartLeft_gauge_1";      //速度仪表盘
import echartGauge2 from "@/views/em/kpiLayout/charts/echartLeft_gauge_2";      //速度仪表盘
import echartTorque1 from "@/views/em/kpiLayout/charts/echartLeft_torque_1";    //转矩仪表盘
import echartTorque2 from "@/views/em/kpiLayout/charts/echartLeft_torque_2";    //转矩仪表盘
import echart2 from "@/views/em/kpiLayout/charts/echartLeft_2";     //主电机温度柱状图
import echart5 from "@/views/em/kpiLayout/charts/echartLeft_5";     //定子电流
import echart6 from "@/views/em/kpiLayout/charts/echartLeft_6";     //励磁电流
// import echart3 from "@/views/em/kpiLayout/charts/echartLeft_3";        //当班产量曲线
// import echart4 from "@/views/em/kpiLayout/charts/echartLeft_4";        //当班勾数曲线

//import dataV
//import dvWaterLevel from "@/views/em/kpiLayout/charts/dvWaterLevel";  //水位，屏蔽未用
import dvMap from "@/views/em/kpiLayout/charts/dvMap";  //中间重点设备寿命监控（MES后端录入提取）
import echartCenterBottom from "@/views/em/kpiLayout/charts/echartCenterBottom";  //底部4个监控温度

const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
var icnow = new Date();      // 初始化时间（右上角监控看板时间拼接）
var intervalTimeNow;                // 定义全局定时器，用于清除定时器

export default {
  name: "emRunning",
  mixins: [EmCommonApi],
  components:{runningStatus,echartGauge1,echartGauge2,echartTorque1,echartTorque2,echart2,echart5,echart6,dvMap,echartCenterBottom,dvEmPosition},
  data(){
    return{
      year: icnow.getFullYear(),
      month: icnow.getMonth() + 1,
      date: icnow.getDate(),
      day: days[icnow.getDay() - 1],
      time: icnow.toTimeString().substring(0, 8),


      id_gauge_1: "echarts_gauge_1",
      eTitle_gauge_1: "北车提升机速度",
      id_gauge_2: "echarts_gauge_2",
      eTitle_gauge_2: "南车提升机速度",

      id_torque_1: "echarts_torque_1",
      eTitle_torque_1: "北车电机转速",
      id_torque_2: "echarts_torque_2",
      eTitle_torque_2: "南车电机转速",

      idPos: "dvPos",
      eTitle_pos: "提升机箕斗位置",

      id2: "echarts_2",
      eTitle2: "主电机温度",

      // id3: "echarts_3",
      // eTitle3: "当班产量",
      //
      // id4: "echarts_4",
      // eTitle4: "当班勾数",

      id4: "dataV_4",
      eTitle4: "重点设备寿命监控指标",

      id5: "echarts_5",
      eTitle5: "主电机定子电流(采样-10M)",

      id6: "echarts_6",
      eTitle6: "主电机励磁电流(采样-10M)",

    }
  },
  created() {
    //控制全屏
    if (!screenfull.isFullscreen) {
      screenfull.toggle()
    }
    this.setVisible(false)

    intervalTimeNow = setInterval(() =>{
      let icnow = new Date();
      this.year = icnow.getFullYear();
      this.month = icnow.getMonth() + 1;
      this.date = icnow.getDate();
      this.day = days[icnow.getDay()];
      this.time = icnow.toTimeString().substring(0, 8);
    }, 1000)

  },
  mounted() {
    this.fnResize()
    window.addEventListener('resize', this.fnResize, false)
  },
  computed: {
    // 当前时间
    newTime: function () {
      return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
    }
  },
  beforeDestroy () {

    clearInterval(intervalTimeNow);
    this.setVisible(true);

    window.removeEventListener('resize', this.fnResize, false)
    document.documentElement.style.fontSize = '16px';
  },

  methods: {
    setVisible(visibility) {
      //控制显示Header和Sidebar
      this.$store.commit("base/setShowHeader", visibility, {root: true});
      this.$store.commit("base/setShowSidebar", visibility, {root: true});
    },
    fnResize() {
      //** 这里是屏幕分辨率适配计算   作用：不同的分辨率控制屏幕内容缩放在当前分辨率全屏尺寸下
      //document.documentElement.clientWidth   获取浏览器窗口文档显示区域的宽度，不包括滚动条
      //window.innerWidth 	返回窗口的文档显示区的宽度
      let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
      document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
    },
  }
}
</script>

<style src="../../../assets/css/emRunningKpi.css" scoped>
  /*不能用下面的方式import，scoped不起作用，全局作用域了*/
  /*@import url("../../../assets/css/emRunningKpi.css");*/



</style>
